// Modules
import React from 'react';
import PropTypes from 'prop-types';
import { pick, assign, get } from 'lodash';

// Components
import TimeReportForm from './time-report-form';
import FormPopover from 'components/widgets/overlays/form';
import { EditButton } from 'components/widgets/buttons/buttons';
import Tooltip from 'components/widgets/overlays/tooltip';
import SVG from 'components/widgets/icons/svg';


// Component
export default class EditTimeReportPopup extends React.Component {
  static propTypes = {
    report: PropTypes.object,
    eagerUpdate: PropTypes.func,
    className: PropTypes.string
  };

  constructor(props) {
    super(props);

    this.editForms = {};
    this.eagerUpdate = this.eagerUpdate.bind(this);
  }

  eagerUpdate(values, toggle = true) {
    if (toggle) this.editForms[values.id].toggle();
    if (this.props.eagerUpdate) this.props.eagerUpdate(values);
  }

  render() {
    const { className, report, ...passed } = this.props;
    const initialValues = { rate: get(report, 'rate.id', 0) };

    return (
      <div className={className}>
        { !report.invoice &&
          <FormPopover
            ref={(el) => { this.editForms[report.id] = el; }}
            target={<EditButton />}
            title="Edit Time Report"
          >
            <TimeReportForm
              {...passed}
              editing={report}
              eagerUpdate={this.eagerUpdate}
              initialValues={assign(initialValues, pick(report, [
                'duration',
                'createdBy',
                'date',
                'description',
                'afterHours',
                'afterHoursPremium'
              ]))}
              agreement={report.agreement}
              form={`edit-time-report-${report.id}`}
            />
          </FormPopover>
        }
        { report.invoice &&
          <Tooltip title="This time report has been invoiced and can't be edited">
            <SVG src="svg/edit.svg" className="svg-only-button deemphasized-button disabled" />
          </Tooltip>
        }
      </div>
    );
  }
}
